export const it_event= {
    title: 'Crea evento',
    edit_title: 'Modifica evento',
    label_title: 'Nome',
    label_description: 'Descrizione',
    label_start_at: 'Data inizio',
    label_end_at: 'Data fine',
    label_calendar_name: 'Calendario',
    question_operation_title: 'Seleziona operazione',
    question_title: 'Conferma cancellazione',
    label_selection: 'Seleziona il calendario',
    label_button_delete: 'Cancella',
    label_detail: 'Modifica',
    question_delete: 'Sei sicuro di voler cancellare questo evento?',
    question: 'Scegli un operazione da eseguire'
}